import SwitchOffIcon from 'components/elements/icons/SwitchOffIcon'
import SwitchOnIcon from 'components/elements/icons/SwitchOnIcon'
import React from 'react'

/**
 * スイッチシンボル
 */
const SwitchSymbol: React.FC<SwitchSymbolProps> = (props) => {
  const SwitchIcon = props.isSwitched ? SwitchOnIcon : SwitchOffIcon
  return <SwitchIcon width={props.width} height={props.height} />
}

export type SwitchSymbolProps = {
  isSwitched: boolean
  width?: string
  height?: string
}

export default SwitchSymbol
